import { createSlice } from '@reduxjs/toolkit';
import { EMPTY_ARRAY } from '../../../helpers/menuItemMapper';
const initialState = {
	data: {
		public: null,
		protected: null,
	},
	loading: false,
	error: null,
};

const menuConfigSlice = createSlice({
	name: 'menuConfig',
	initialState,
	reducers: {
		setPublicMenuData: (state, action) => {
			state.data.public = action.payload;
			state.loading = false;
			state.error = null;
		},
		setProtectedMenuData: (state, action) => {
			state.data.protected = action.payload;
			state.loading = false;
			state.error = null;
		},
		setMenuData: (state, action) => {
			// Option to set both at once if needed
			state.data.public = action.payload.public;
			state.data.protected = action.payload.protected;
			state.loading = false;
			state.error = null;
		},
		setLoading: (state, action) => {
			state.loading = action.payload;
		},
		setError: (state, action) => {
			state.error = action.payload;
			state.loading = false;
		},
		clearMenuData: (state) => {
			state.data.public = null;
			state.data.protected = null;
			state.loading = false;
			state.error = null;
		},
		clearPublicMenuData: (state) => {
			state.data.public = null;
		},
		clearProtectedMenuData: (state) => {
			state.data.protected = null;
		},
	},
});

export const {
	setPublicMenuData,
	setProtectedMenuData,
	setMenuData,
	setLoading,
	setError,
	clearMenuData,
	clearPublicMenuData,
	clearProtectedMenuData
} = menuConfigSlice.actions;

export default menuConfigSlice.reducer;

// Selectors for easy access
export const selectPublicMenus = (state) => state.menuConfig?.data?.public?.data || EMPTY_ARRAY;
export const selectProtectedMenus = (state) => state.menuConfig?.data?.protected || EMPTY_ARRAY;
export const selectAllMenus = (state) => state.menuConfig?.data;
export const selectMenuLoading = (state) => state.menuConfig?.loading;
export const selectMenuError = (state) => state.menuConfig?.error;